
/**
 *      Data-driven UI logic for Handlebars macros
 *
 *      @author Irina Patrikeeva <irina.i.ipatrikeeva@nasa.gov>
 *
 *      Created on 06/02/2017
 *      Modified on 08/16/2018
 */


/**
 * Apply mathematical operations and return an integer value
 */
Handlebars.registerHelper("math", function(lvalue, operator, rvalue, options) {
    lvalue = parseInt(lvalue);
    rvalue = parseInt(rvalue);

    // TODO: check that the sum and difference did not overflow using max allowed integer value
    // also check that for division, the divisor is not zero

    return {
        "+": Math.ceil(lvalue + rvalue),
        "-": Math.ceil(lvalue - rvalue),
        "*": Math.ceil(lvalue * rvalue),
        "/": Math.ceil(lvalue / rvalue),
        "%": Math.ceil(lvalue % rvalue)
    }[operator];
});

/**
 * Assign value to a variable and store it in global page context
 */
Handlebars.registerHelper("setVariable", function( varName, varValue ) {
    setGlobalVariable( varName, varValue );
});

/**
 * Retrieve variable from the global page context
 */
Handlebars.registerHelper("getVariable", function( varName ) {
    return getGlobalVariable(varName);
});

/**
 * Retrieve all global variables from the global page context
 */
Handlebars.registerHelper("getVariables", function( ) {
    return GlobalPageState.vars;
});

/*** Compare block helper for Handlebars ***/
/*** example: {{#compare unicorns ponies operator=">"}}
 I knew it, unicorns are just low-quality ponies!
 {{/compare}}

 Defaults to == if operator omitted.
 From http://doginthehat.com.au/2012/02/comparison-block-helper-for-handlebars-templates/
 ***/
Handlebars.registerHelper('compare', function (lvalue, rvalue, options) {
    var operator = options.hash.operator || "==",
        operators,
        result;
    if (arguments.length < 3) {
        throw new Error("Handlerbars Helper 'compare' needs 2 parameters");
    }

    operators = {
        '==': function (l, r) {
            return l == r;
        },
        '===': function (l, r) {
            return l === r;
        },
        '!=': function (l, r) {
            return l != r;
        },
        '!==': function (l, r) {
            return l !== r;
        },
        '<': function (l, r) {
            return l < r;
        },
        '>': function (l, r) {
            return l > r;
        },
        '<=': function (l, r) {
            return l <= r;
        },
        '>=': function (l, r) {
            return l >= r;
        },
        'typeof': function (l, r) {
            return typeof l === r;
        }
    };

    if (!operators[operator]) {
        throw new Error("Handlebars Helper compare doesn\'t know the operator " + operator);
    }

    result = operators[operator](lvalue, rvalue);

    if (result) {
        return options.fn(this);
    } else {
        return options.inverse(this);
    }

});

/*** Handlebars helper for a basic for loop
 * ex: (#for from to increment)
 ***/
Handlebars.registerHelper('for', function (from, to, incr, block) {
    var accum = '',
        i;
    for (i = from; i <= to; i += incr) {
        accum += block.fn(i);
    }
    return accum;
});

/**
 * Handlebars helper for search pagination
 */
Handlebars.registerHelper('pagination', function (nPages, block) {
    var accum = '',
        i,
        context,
        nVisible = 10; // number of visible pages
    if (App.globalState.currentPage < 7) {
        for (i = 1; i <= Math.min(nPages, nVisible); ++i) {
            context = {page: i};
            if (i === App.globalState.currentPage) {
                context.classes = 'disabled';
                context.itemClasses = 'active';
            }
            accum += block.fn(context);
        }
    } else if (App.globalState.currentPage > nPages - 7) {
        for (i = Math.max(nPages - nVisible + 1, 1); i <= nPages; i++) {
            context = {page: i};
            if (i === App.globalState.currentPage) {
                context.classes = 'disabled';
                context.itemClasses = 'active';
            }
            accum += block.fn(context);
        }
    } else {
        for (i = App.globalState.currentPage - nVisible / 2; i < App.globalState.currentPage + nVisible / 2; ++i) {
            if (i <= nPages) {
                context = {page: i};
                if (i === App.globalState.currentPage) {
                    context.classes = 'disabled';
                    context.itemClasses = 'active';
                }
                accum += block.fn(context);
            }
        }
    }

    return accum;
});

/**
 * Handlebars helper to check if URL is external
 */
Handlebars.registerHelper('ifExternal', function (url, block) {
    if ( isExternal( url ) ) {
        return block.fn();
    }
});

/**
 * Handlebars helper to format a date
 */
Handlebars.registerHelper('formatDate', function (dateValue) {
    return formatDate(dateValue);
});

/**
 * Handlebars helper to remove all HTML tags except br and p
 */
Handlebars.registerHelper('sanitizeText', function (value) {
    return sanitizeText(value);
});

/**
 * Handlebars helper to remove all HTML tags
 */
Handlebars.registerHelper('sanitizeAll', function (value) {
    return sanitizeAll(value);
});

/*** Handlebars template for a single record row ***/
Handlebars.registerHelper('recordRow', function(label, value) {
    return constructRowElement(label, value);
});

/*** Handlebars template for a single record row with date value ***/
Handlebars.registerHelper('recordRowDate', function(label, value) {
    return constructRowElement(label, formatDate(value));
});

/*** Handlebars template for a half row ***/
Handlebars.registerHelper('recordRowHalf', function(label, value) {
    return constructRowHalfElement(label, value);
});

/*** Handlebars template for a half row with date value ***/
Handlebars.registerHelper('recordRowHalfDate', function(label, value) {
    return constructRowHalfElement(label, formatDate(value));
});

/**
 * Handlebars template for a viewer link icon
 */
Handlebars.registerHelper('viewerLink', function( item ) {
    return constructViewerLink( item );
});

/**
 * Handlebars template for an EDI URL element
 */
Handlebars.registerHelper('ediLink', function( item ) {
    return constructEDILink( item );
});

/**
 * Handlebars template for an EDI email element
 */
Handlebars.registerHelper('ediEmail', function( item ) {
    return constructEDIEmail( item );
});

/**
 * Handlebars template for an EDI link to search page
 */
Handlebars.registerHelper('searchLink', function( item ) {
    return constructSearchLink( item );
});

/**
 * Handlebars template for an EDI record row
 */
Handlebars.registerHelper('formatRecordRow', function( item ) {
    return formatRecordRow( item );
});

/**
 * Handlebars template for an EDI search snippet
 */
Handlebars.registerHelper('formatSearchRecord', function( items ) {
    return formatSearchRecord( items );
});


/**
 * Handlebars template to format source link
 */
Handlebars.registerHelper('formatTitleLink', function( item ) {
    return formatTitleLink( item );
});

/**
 * Handlebars template to format edit link
 */
Handlebars.registerHelper('formatEditLink', function( item ) {
    return formatEditLink( item );
});

/**
 * Handlebars template to format Common Data Model (CDM) button
 */
Handlebars.registerHelper('formatCDMButton', function( item ) {
    return formatCDMButton( item );
});

/**
 * Handlebars template to format EDI Data Model button
 */
Handlebars.registerHelper('formatEDIModelButton', function( item ) {
    return formatEDIModelButton( item );
});

/**
 * Handlebars template to format export to PDF button
 */
Handlebars.registerHelper('formatExportPDFButton', function( item ) {
    return formatExportPDFButton( item );
});

/**
 * Handlebars template to format source link
 */
Handlebars.registerHelper('formatSourceLink', function( item ) {
    return formatSourceLink( item );
});

/**
 * Handlebars template to format FOD Wiki images
 */
Handlebars.registerHelper('fodItemsView', function( items ) {
    return formatFODItems( items );
});

/**
 * Helper functions
 */

/**
 * Check if the input URL goes outside the EVA site. Returns true if link is external and false otherwise.
 * @param url {string} - URL string
 * @returns {boolean}
 */
function isExternal( url ) {
    var result = false;
    if ( url && typeof url === "string" && ( ( url.indexOf('/') !== 0 && url.indexOf( window.location.protocol + '//' + window.location.hostname ) !== 0 ) ) ) {
        result = true;
    }
    return result;
}

/**
 * Save a variable into the global vars object
 * @param name {string} - variable name
 * @param value {*} - variable value
 */
function setGlobalVariable( name, value ) {
    if ( !GlobalPageState ) {
        GlobalPageState =  {};
    }
    if ( !GlobalPageState.vars ) {
        GlobalPageState.vars = {}
    }
    if ( name && value ) {
        GlobalPageState.vars[ name ] = value;
    }
}
/**
 * Construct a single row DOM element
 * @param label {string} - field label
 * @param value {string} - field value
 */
function constructRowElement(label, value) {
    var result = '';
    if (!(value === null || value === undefined) && !(label === null || label === "" || label === undefined)) {
        if (value.toString().trim() !== "") {
            result = '<div class="row record-row"><div class="col-xs-12 col-sm-3 record-field-label"><strong>' + sanitizeAll(label) + ':</strong></div><div class="col-xs-12 col-sm-9 col-md-9 field-value">' + sanitizeText(value) + '</div></div>';
        }
    }
    return new Handlebars.SafeString(result);
}

/*** Construct a DOM element that takes half a row
 * @label field label (string)
 * @value field value
 * ***/
function constructRowHalfElement(label, value) {
    var result = '';
    if (!(value === null || value === undefined) && !(label === null || label === "" || label === undefined)) {
        if (value.toString().trim() !== "") {
            result = '<div class="col-xs-12 col-sm-6"><div class="row record-row"><div class="col-sm-5 record-field-label text-right"><strong>' + sanitizeAll(label) + ':</strong></div><div class="col-sm-7 field-value">' + sanitizeText(value) + '</div></div></div>';
        }
    }
    return new Handlebars.SafeString(result);
}

/**
 * Return a global variable value by name if it exists
 * @param varName {string} - variable name
 * @returns {*}
 */
function getGlobalVariable( varName ){
    var result;
    if ( GlobalPageState && GlobalPageState.vars && varName ){
        result = GlobalPageState.vars[varName];
    }
    return result;
}

/**
 * Construct a string representation of the search snippet title
 * @param item {object} - record title field object
 * @returns {string}
 */
function constructSearchRecordTitle( item ) {

    var result = '',
        typeName = getGlobalVariable("typeName"),
        ediType = getGlobalVariable("ediType"),
        id = getGlobalVariable("id"),
        ediId = getGlobalVariable("ediId"),
        sarahEdiId = getGlobalVariable("sarahEdiId"),
        asaId = getGlobalVariable("asaIdentifier"),
        crdbId = getGlobalVariable("CRDB_RECORD_ID");

    if ( item ) {
        result += '<div class="row">';
        result += '<a class="title"';

        if ( typeName ) {
            result += ' type=' + typeName;
        } else if ( ediType ) {
            result += ' type=' + ediType;
        }

        // TODO: replace this logic once ediId is on every record
        if ( crdbId ) {
            result += ' id=' + crdbId;
        }
        else if ( id ) {
            result += ' id=' + id;
        }
        else if ( ediId ) {
            result += ' id=' + ediId;
        }
        else if ( sarahEdiId ) {
            result += ' id=' + sarahEdiId;
        }
        else if ( asaId ) {
            result += ' id=' + asaId;
        }

        result += ' title="View metadata"';

        if ( item.field ) {
            result +=  ' name=' + item.field;
        }
        result += '>';

        if ( item.value ) {
            result += sanitizeAll( item.value );
        }
        result += '</a>';
        result +='</div>';
    }

    return result;
}

/**
 * Construct a string representation for one search snippet item
 * @param item {object} - record field JavaScript object
 * @returns {string}
 */
function constructSearchRecordRow( item ) {

    var result = '',
        label,
        itemField,
        itemLabel,
        itemValue;

    if ( item ) {
        result += '<div class="row">';

        var itemField = item.field;
        var itemLabel = item.label;
        var itemValue = item.value;
        var itemHidden = item.hidden;

        if ( itemHidden ) {
            result += '<li class="item hidden" ';
        } else {
            result += '<li class="item" ';
        }

        if ( itemField ) {
            result += 'name="' + itemField;
        }
        result += '">';

        if ( itemLabel ) {
            label = sanitizeAll( itemLabel );
            result += '<strong>' + label + '</strong>: ';
        }

        if ( itemValue ) {
            result += formatRecordRowString( item );
        }

        result += '</li>';
        result +='</div>';
    }

    return result;
}

/**
 * Construct a string representation of a link to authoritative source
 * @param item {object} - record field JavaScript object
 * @returns {*}
 */
function constructSourceLink( item ) {

    var result = '',
        value;

    if ( item ) {
        result += '<a class="source-link"';
        if ( item.url && item.value ) {
            value = sanitizeAll( item.value );
            result += ' href=' + encodeURI( value );

            // Open external links in new tab
            if ( isExternal( value )) {
                result += ' target=_blank';
            }
        }

        result += ' title="View authoritative source"';
        result += '>';
        result += "Authoritative source";
        result += '</a>';
    }

    return result;
}


/**
 * Construct a string representation of an array of items, separated by a new line
 * @param item {object} - record field JavaScript object
 * @returns {string}
 */
function constructExpandedText( item ) {
    var result = '',
        element,
        i;

    // Check that the item has an expanded flag
    if ( item && item.expanded && item.expanded.toString() === "true" ) {
        // Check that the item has a multiple flag
        // Only an item that contains an array of values can have a valid expanded flag
        if ( item.multiple && item.multiple.toString() === "true" ) {
            // Check that the item has a value
            if ( item.value && Array.isArray( item.value )) {
                // Check that the value contains at least one element
                for ( i = 0; i < item.value.length; i++ ) {


                    element = sanitizeAll( item.value[ i ] );

                    if ( element ) {
                        if ( i < item.value.length - 1 ) {
                            // Add a new line at the end of each value array element
                            result += '<div white-space="pre">' + element + '</div>';
                        } else {
                            // Do not append the new line to the last element
                            result += '<div>' + element + '</div>';
                        }
                    }
                }
            }
        }
    }
    return result;
}

/**
 * Construct a string representation of the EDI viewer link element
 * @param viewerType {string} - viewer data type
 * @param value {string} - display value
 * @param hasIcon {boolean} - true if viewer icon is included
 * @returns {string}
 */
function buildViewerElement( viewerType, value, hasIcon ) {
    var result = '',
        title = "EDI Viewer";

    if ( viewerType && value ) {
        if ( viewerType === "part" || viewerType === "emupart" ) {
            title = "Part Viewer";
        }
        if ( viewerType === "component" || viewerType === "emucomponent" ) {
            title = "Component Viewer";
        }
        result += '<a class="viewer-link" title="' + title + '" alt="' + title + '" onclick="clickViewerLink(\'' + value + '\',\'' + viewerType + '\')">' + value;

        if ( hasIcon ) {
            result += '<img src="/edi/images/part-viewer.svg" title="' + title + '" alt="' + title + '">';
        }

        result += '</a>';
    }
    return result;
}

/**
 * Construct a string representation of the viewer link
 * @param item {object} - record field JavaScript object
 * @returns {string}
 */
function constructViewerLink( item ) {

    var result = '',
        value,
        i;

    if ( item ) {
        result += '<span>';

        if ( item.value && item.has_viewer ) {
            if ( item.multiple ) {
                // Create a link for each item in the array
                for ( i = 0; i < item.value.length; i++ ) {
                    value = sanitizeAll( item.value[ i ] );
                    result += buildViewerElement( item.has_viewer, value, false );
                }
            } else {
                value = sanitizeAll( item.value );
                result += buildViewerElement( item.has_viewer, value, true );
            }
        }
        result += '</span>';
    }
    return result ;
}

/**
 * Construct a string representation of the EDI link element. External link opens in a new tab.
 * @param value {string} - link value
 * @returns {string}
 */
function buildLinkElement( value ) {
    var result = '';

    if ( value ) {
        if ( isValidLink( value ) ) {
            result += '<a class="edi-link-right" title="EDI link" href="' + encodeURI( value ) + '"';
            if ( isExternal( value )) {
                result +=' target="blank">External EDI Link</a>';
            }
            else {
                result +='>EDI Link</a>';
            }
        } else {
            if ( value.substr(0,1) !== '#' ) {
                result += sanitizeText( value );
            }
        }
    }

    return result;
}

/**
 * Check if the value is a valid link
 * @param url {string} - URL value
 * @returns {boolean}
 */
function isValidLink( url ) {
    var result = false;

    if ( url && typeof url === "string"){
        result = url.indexOf('/') === 0 || url.indexOf( window.location.protocol + '//' + window.location.hostname ) === 0 || url.indexOf( "https" ) > -1 || url.indexOf( "http" ) > -1 || url.indexOf("www") > -1;
    }

    return result;
}
/**
 * Construct a string representation of the DOM URL link
 * @param item {object} - record field JavaScript object
 * @returns {*}
 */
function constructEDILink( item ) {

    var result = '',
        value,
        i;

    if ( item && item.value && item.is_link ) {

        result += '<span>';

        if ( item.multiple ) {
            // Create a link for each item in the array
            for ( i = 0; i < item.value.length; i++ ) {
                value = sanitizeAll( item.value[ i ] );
                result += buildLinkElement( value );
            }
        } else {
            value = sanitizeAll( item.value );
            result += buildLinkElement( value );
        }
        result += '</span>';
    }

    return result;
}

/**
 * Construct a string representation of the email link element
 * @param value {string} - email value
 * @returns {string}
 */
function buildEmailElement( value ) {
    var result = '';
    if ( value ) {
        result += '<a class="edi-link-right" title="EDI e-mail link" href="mailto:' + value + '"';
        result +='>' + value + '</a>';
    }
   return result;
}

/**
 * Construct a DOM E-mail link
 * @param item {object} - record field JavaScript object
 * @returns {*}
 */
function constructEDIEmail( item ) {

    var result = '',
        value,
        i;

    if ( item && item.value && item.is_email ) {

        result += '<span>';

        if ( item.multiple ) {
            // Create a link for each item in the array
            for ( i = 0; i < item.value.length; i++ ) {
                value = sanitizeAll( item.value[ i ] );
                result = buildEmailElement( value );
            }
        } else {
            value = sanitizeAll( item.value );
            result = buildEmailElement( value );
        }

        result += '</span>';
    }

    return new Handlebars.SafeString( result );
}

/**
 * Construct a string representation of the search link element
 * @param value {string} - search query value
 * @param field {string} - field label
 * @returns {string}
 */
function buildSearchLinkElement( value, field ) {

    var linkElement = '';

    if ( value ) {

        // return the original value if "TBD" is the value
        if ( value === "TBD") {
            return value;
        }

        linkElement += '<a class="edi-link-right" title="Search link" href="/search?q=' + encodeURIComponent( value ) + '"';
        linkElement +='>' + value;
        if ( field ) {
            linkElement += '<i class="fa fa-link edi-link-left" alt="Search for "' + field + '></i>';
        } else {
            linkElement += '<i class="fa fa-link edi-link-left" alt="EDI search"></i>';
        }

        linkElement += '</a>';
    }
    return linkElement;
}

/**
 * Construct a DOM link to the search page with value. Ignore "TBD" values.
 * @param item {object} - input field JavaScript object
 * @returns {*}
 */
function constructSearchLink( item ) {

    var result = '',
        value,
        i;

    if ( item && item.value && item.is_searchable ) {

        if ( item.multiple ) {
            // Create a link for each item in the array
            for ( i = 0; i < item.value.length; i++ ) {
                value = sanitizeAll( item.value[ i ] );
                result = buildSearchLinkElement( value, item.label );
            }
        } else {
            value = sanitizeAll( item.value );
            result = buildSearchLinkElement( value, item.label );
        }

        result += '</span>';
    }
    return new Handlebars.SafeString( result );
}

/**
 * Construct a DOM element for a record row element
 * @param item {object} - input field JavaScript object
 */
function formatRecordRow( item ) {

    var result = formatRecordRowString( item );
    return new Handlebars.SafeString( result );
}

/**
 * Construct a string representation of a record value
 * @param item {object} - record field object
 * @returns {*}
 */
function formatRecordRowString( item ) {

    var result = '';

    if ( item && item.type && item.type !== "object") {
        if ( item.type === "date" ) {
            result = formatDate( item.value );
        }
        else if ( item.has_viewer ) {
            result = constructViewerLink( item );
        }
        else if ( item.is_link ) {
            if ( item.url ) {
                result = constructSourceLink( item );
            } else {
                result = constructEDILink( item );
            }
        }
        else if ( item.is_email ) {
            result = constructEDIEmail( item );
        }
        else if ( item.is_searchable ) {
            result = constructSearchLink( item );
        }
        else if ( item.url ) {
            result = constructSourceLink( item );
        }
        else if ( item.expanded ) {
            result = constructExpandedText( item );
        }
        else {
            result = sanitizeText( item.value );
        }
    }
    return result;
}

// TODO: replace this logic once ediId is on every record
/**
 * Set global id and type variables to hold values needed for display
 * @param items
 */
function setGlobalIds( items ) {
    var item,
        itemField,
        itemName,
        itemValue,
        i;

    if ( items ) {

        // clear previously stored global variables
        GlobalPageState.vars = {};

        for ( i = 0; i < items.length; i++ ) {
            item = items[i];
            if ( item ) {
                itemField = item.field;
                itemName = item.name;
                itemValue = item.value;

                if ( itemField === "edi_type" ) {
                    setGlobalVariable( "ediType", itemName );
                }
                if ( itemField === "type" ) {
                    setGlobalVariable( "typeName", itemName );
                }
                if ( itemField === "id" ) {
                    setGlobalVariable( "id", itemValue );
                }
                if ( itemField === "edi_id" ) {
                    setGlobalVariable("ediId", itemValue);
                }
                if ( itemField === "sarahEdiId" ) {
                    setGlobalVariable( "sarahEdiId", itemValue );
                }
                if ( itemField === "asaIdentifier" ) {
                    setGlobalVariable( "asaIdentifier", itemValue );
                }
                if ( itemField === "CRDB_RECORD_ID" ) {
                    setGlobalVariable( "CRDB_RECORD_ID", itemValue );
                }
            }

        }
    }
}

/**
 * Construct a DOM element for one search snippet
 * @param itemsObject {object} - JavaScript object containing an array of items in the search snippet
 */
function formatSearchRecord( itemsObject ) {

    var result = '',
        items,
        item,
        i;

   if ( hasKeys( itemsObject ) ) {
       items  = itemsObject.items;
       if ( items ) {
           // TODO replace this logic once every record has edi_id
           setGlobalIds( items );

           //type = getItemsType ( items );

           for ( i = 0; i < items.length; i++ ) {
               item = items[ i ];
               if ( item && item.value ) {
                   // The first field becomes the title for the search snippet.
                   // If that field is "title" both "title" and "id" fields are used to construct a link to the details page.
                   if ( i === 0 ) {
                       result += constructSearchRecordTitle( item );
                   } else if ( item.is_link || ! ( item.field === "title" || item.field === "id" )) {
                       result += constructSearchRecordRow( item );
                   }
               }
           }
       }
   }
    return new Handlebars.SafeString( result );
}

/**
 * Construct authoritative source document link in the record title if it exists
 * @param item {object} - JavaScript row object
 * @returns {*}
 */
function formatTitleLink( item ) {
    var result = '',
        urlValue,
        url;

    if ( item ) {

        var alias = App.globalState.alias;
        // Construct a special FOD Wiki link back to source
        if ( alias === "fod" ) {

            var titleLink = convertToFODLinkFormat( item.title );

            if ( titleLink ) {
                urlValue = "https://wiki.jsc.nasa.gov/iss/index.php/" + titleLink;
            }

        } else {
            // Construct link back to source from either the item url field or from the item model base_url field
            url = item.url;
            if ( url && isValidLink( url ) ) {
                urlValue = url;
            } else {
                // construct URL value from base_url or search_url
                urlValue = getBaseUrlValue( item );
            }
        }

    }

    // Create authoritative link element
    if ( urlValue ) {
        result += '<h6>';
        result += '<a href="' + urlValue + '"';
        if ( isExternal( urlValue )) {
            result += ' target="_blank"';
        }
        result += '><i class="fa fa-link"></i>Authoritative source document</a>';
        result += '</h6>';
    }
    return new Handlebars.SafeString( result );
}

/**
 * Construct edit link in the record title region if it exists
 * @param item {object} - JavaScript row object
 * @returns {*}
 */
function formatEditLink( item ) {
    var result = '',
        urlValue;

    if ( item ) {

        // construct URL value from edit_url object
        urlValue = getEditUrlValue( item );
    }

    if ( urlValue ) {
        result += '<h6>';
        result += '<a href="' + urlValue + '"';
        if ( isExternal( urlValue )) {
            result += ' target="_blank"';
        }
        result += '><i class="fa fa-link"></i>Edit document</a>';
        result += '</h6>';
    }
    return new Handlebars.SafeString( result );
}


/**
 * Construct CDM view button link in the record title if it exists
 * @returns {*}
 */
function formatCDMButton( item ) {

    var result = '',
        cdmExists,
        type,
        cdm;

    if ( item ) {
        cdm = item.cdm;

        if ( cdm ) {
            cdmExists = true;
        } else {
            if ( GlobalPageState && GlobalPageState.type ) {
                type = GlobalPageState.type;
                if ( type ) {
                    // construct CDM view link
                    cdmExists = getCDMView( type );
                }
            }
        }

        // Per USRA-604, part and component viewer must include CDM view
        if ( GlobalPageState && cdmExists && ( item.cdm || GlobalPageState.view === "edi" ) ) {
            result += '<input class="button button-primary" name="show-cdm" title="View common data model" type="button" value="View common data model" onclick="showDataView(\'cdm\',\'edi\')">';
            result += '</input>';
        }
    }

    return new Handlebars.SafeString( result );
}

/**
 * Construct EDI model view button link in the record title
 * @returns {*}
 */
function formatEDIModelButton( item ) {

    var result = '',
        edi;

    if ( item ) {
        edi = item.edi;

        if ( edi ) {
            result += '<input class="button button-primary" name="show-edi" title="View source data model" type="button" value="View source data model" onclick="showDataView(\'edi\',\'cdm\')">';
            result += '</input>';
        }

    }

    return new Handlebars.SafeString( result );
}


/**
 * Construct export to PDF button
 * @returns {*}
 */
function formatExportPDFButton( item ) {

    var result = '';

    if ( item ) {

        result += '<button class="button edi-button" title="Export to PDF" id="export-to-pdf" onclick="exportToPdf(\'' + item.title + '\', \'' + item._type + '\')">';
        result += '<i class="fa fa-file-pdf"></i>PDF';
        result += '</button>';
    }

    return new Handlebars.SafeString( result );
}

/**
 * Construct EDI model source link in the record title
 * @returns {*}
 */
function formatSourceLink( item ) {

    var result = '',
        source;

    if ( item ) {

        // construct source object from model source object
        source = getSourceObject( item );

        if ( source && source.label ) {
            result += '<h6><strong>Source:</strong> ';
            if ( source.url ) {

                result += '<a href="' + source.url + '" title="' + source.label + '"';
                if ( isExternal( source.url )) {
                    result += ' target="_blank"';
                }
                result += '>' + source.label + '</a>';

            } else {
                result += source.label;
            }
            result += '</h6>';
        }
    }

    return new Handlebars.SafeString( result );
}

/**
 * Format FOD Wiki images
 * @param items {Array} - array of FOD Wiki search images
 * @return {Handlebars.SafeString}
 */
function formatFODItems( items ) {

    var result = '',
        topItem,
        titleLink,
        title,
        description;


    if ( items && items.length > 0 ) {

        topItem = items[0];


        // Display the first 6 items in a grid
        result += '<div class="row search-images">';

        // Create the first row of images
        result += '<div class="full-row pull-left">';

        // Left half of the first row
        result += '<div class="one-half">';
        result += createImageItem( topItem );

        // Close the left half of the first row
        result += '</div>';

        // Right half of the first row
        result += '<div class="one-half">';
        if ( items.length > 1 ) {

            result += '<div class="one-half">';
            result += createImageItem( items[ 1 ] );
            result += '</div>';

            if ( items.length > 2 ) {
                result += '<div class="one-half">';
                result += createImageItem( items[ 2 ] );
                result += '</div>';
            }
        }
        // Close the right half of the first row
        result += '</div>';


        // Create the second row of images

        // Right half of the second row
        result += '<div class="one-half">';
        if ( items.length > 3 ) {
            result += '<div class="one-third">';
            result += createImageItem( items[ 3 ] );
            result += '</div>';
        }
        if ( items.length > 4 ) {
            result += '<div class="one-third">';
            result += createImageItem( items[ 4 ] );
            result += '</div>';
        }
        if ( items.length > 5 ) {
            result += '<div class="one-third">';
            result += createImageItem( items[ 5 ] );
            result += '</div>';
        }
        // Close the right half of the second row
        result += '</div>';

        // Close the row of images
        result += '</div>';

        // Create the text div under the images
        result += '<div class="full-row pull-left">';
        if ( topItem ) {

            title = topItem.title;
            var displayTitle = topItem.displayTitle;
            if ( displayTitle ) {
                result += '<div class="image-title title">';
                result += '<p class="font-lead">' + displayTitle + '</p>';
                result += '</div>';
            }
            description = topItem.edi_description;
           if ( description ) {
               result += '<div class="full-row record-row">';
               result += '<p class="field-value image-description">' +  sanitizeAll( description ) + '</p>';
               result += '</div>';
           }
           if ( topItem.src ) {
                result += '<div class="one-half record-row image-link">';
                result += '<a href="/view/fod/fodwiki/' + topItem.pageid + '">Record Viewer</a>';
                result += '</div>';
            }
            // Create link back to authoritative source document
            if ( title ) {
                titleLink = convertToFODLinkFormat( title );
                if ( titleLink ) {
                    result += '<div class="one-half record-row image-link-right">';
                    result += '<a href="https://wiki.jsc.nasa.gov/iss/index.php/' + titleLink + '" target="_blank">Authoritative Source</a>';
                    result += '</div>';
                }
            }
        }


        // Close the text div
        result += '</div>';

        // Close the outer div
        result += '</div>'
    }

    return new Handlebars.SafeString( result );
}

/**
 * Create search item for FOD Wiki image
 * @param item {object} - FOD Wiki image record
 * @return {string}
 */
function createImageItem( item ) {

    var result = '';

    if ( item && item.pageid ) {
        result += '<a href="/view/fod/fodwiki/' + item.pageid + '">';
        result += '<div class="image-wrap">';
        if ( item.src && item.title ) {

            result += '<img class="search-image" src="' + item.src + '" title="' + item.title + '" alt="FOD Wiki image">';
        }
        result += '<div class="image-caption">' + item.title + '</div>';
        result += '</div>';
        result += '</a>';
    }

    return result;
}